import {h, render} from 'preact';

const hideButton = button => {
  button.style.opacity = 0;
  setTimeout(() => {
    button.style.height = '0px';
  }, 700);
};

const showButton = button => {
  button.style.height = null;
  button.style.opacity = null;
};

const adjustMaxHeight = (element, delay, delay2) => {
  setTimeout(() => {
    element.style.maxHeight = `${element.scrollHeight + 20}px`;
    if (delay2) {
      setTimeout(() => {
        element.style.maxHeight = `${element.scrollHeight + 20}px`;
      }, delay2);
    }
  }, delay);
};

const getTags = (elements) => {
  return elements.map(element => ({
    destinations: JSON.parse(element.getAttribute('data-destinations') || "[]"),
    classifications: JSON.parse(element.getAttribute('data-classifications') || "[]")
  }));
};

const getUniqueObjectProperties = propertyName => objects => {
  return objects
    .reduce((merged, obj) => merged.concat(obj[propertyName]), [])
    .filter((value, index, merged) => merged.indexOf(value) === index);
};

const transliterateAndSimplify = value => {
  return String(value).toLowerCase()
    .replace('ä', 'ae')
    .replace('ö', 'oe')
    .replace('ü', 'ue')
    .replace('ß', 'sz');
};

const compareStringsForSorting = (a,b) => {
    const aT = transliterateAndSimplify(a);
    const bT = transliterateAndSimplify(b);

    if (aT > bT) {
      return 1;
    }

    if (aT < bT) {
      return -1;
    }

    return 0;
};

const getUniqueDestinations = getUniqueObjectProperties('destinations');
const getUniqueClassifications = getUniqueObjectProperties('classifications');

const startOrders = {
  klassenfahrten: ['Städtereisen', 'Rundreisen', 'Aktivreisen'],
  gruppenreisen: ['Städtereisen', 'Rundreisen', 'Kurzreisen']
};

const Title = ({title, tags, handleDestinationChange, handleClassificationChange, selectedDestination, selectedClassification, enableDestinationFilter, enableClassificationFilter, section}) => {

  let selectedDestinationTags = [];
  let destinations = [];
  let globalDestinations = [];
  let selectableDestinations = [];

  let selectedClassificationTags = [];
  let classifications = [];
  let globalClassifications = [];
  let selectableClassifications = [];

  if (enableDestinationFilter) {
    selectedDestinationTags = tags.filter(tag => selectedClassification ? tag.classifications.includes(selectedClassification) : true);
    destinations = getUniqueDestinations(selectedDestinationTags).sort( compareStringsForSorting );
    // disabled as experiment to find out wether this is more understandable for editors and users
    // @todo: evaluate wich of the approaches shall be used finally
    // globalDestinations = destinations.filter(destination => tags.every(tag => tag.destinations.includes(destination)));
    // selectableDestinations = destinations.filter(destination => !globalDestinations.includes(destination));
    globalDestinations = [];
    selectableDestinations = destinations;
  }

  if (enableClassificationFilter) {
    selectedClassificationTags = tags.filter(tag => selectedDestination ? tag.destinations.includes(selectedDestination) : true);
    classifications = getUniqueClassifications(selectedClassificationTags).sort( compareStringsForSorting );
    if (section && startOrders[section]) {
      classifications = [...startOrders[section].filter(value=>classifications.includes(value)), ...classifications.filter(value=>!startOrders[section].includes(value))]
    }
    // disabled as experiment to find out wether this is more understandable for editors and users
    // @todo: evaluate wich of the approaches shall be used finally
    // globalClassifications = classifications.filter(classification => tags.every(tag => tag.classifications.includes(classification)));
    // selectableClassifications = classifications.filter(classification => !globalClassifications.includes(classification));
    globalClassifications = [];
    selectableClassifications = classifications;
  }

  return (
    <span>
      {title}
      {(!!globalDestinations.length || !!selectableDestinations.length) && ' in das Reiseziel '}
      {globalDestinations.join(', ')}
      {!!globalDestinations.length && !!selectableDestinations.length && ', '}
      {
        !!selectableDestinations.length && <span className="teaserSimple__selectWrapper">
          <select onChange={handleDestinationChange} value={selectedDestination} className="teaserSimple__filterSelect">
            <option value="">auswählen</option>
            {selectableDestinations.map(destination => <option key={destination} value={destination}>{destination}</option>)}
          </select>
          <i className="teaserSimple__filterIcon fa fa-chevron-down"/>
        </span>
      }
      {(!!globalClassifications.length || !!selectableClassifications.length) && ' zu dem Reisethema '}
      {globalClassifications.join(', ')}
      {!!globalClassifications.length && !!selectableClassifications.length && ', '}
      {
        !!selectableClassifications.length && <span className="teaserSimple__selectWrapper">
          <select onChange={handleClassificationChange} value={selectedClassification} className="teaserSimple__filterSelect">
            <option value="">auswählen</option>
            {selectableClassifications.map(classification => <option key={classification} value={classification}>{classification}</option>)}
          </select>
          <i className="teaserSimple__filterIcon fa fa-chevron-down"/>
        </span>
      }
    </span>
  );
};

export default el => {
  const button = el.querySelector('.teaserSimple__moreButton');

  let clicks = 1;
  let selectedDestination;
  let selectedClassification;

  const enableDestinationFilter = el.hasAttribute('data-enable-destination-filter') ? true : false;
  const enableClassificationFilter = el.hasAttribute('data-enable-classification-filter') ? true : false;
  const limit = el.getAttribute('data-limit');
  const elements = [].slice.call(el.querySelectorAll('.teaserSimpleElement'))
    .map(element => {
      element.data = {
        destinations: JSON.parse(element.getAttribute('data-destinations') || "[]"),
        classifications: JSON.parse(element.getAttribute('data-classifications') || "[]")
      };
      return element;
    });
  const elementWrapper = el.querySelector('.teaserSimple__elementWrapper');
  const section = el.getAttribute('data-section');

  const tags = getTags(elements);

  const titleElement = el.querySelector('.teaserSimple__title');
  const titleText = titleElement.innerText;

  const handleDestinationChange = event => {
    selectedDestination = event.target.value;
    handleFilterChange({visibleCount: clicks * limit});
    renderTitle();

    adjustMaxHeight(elementWrapper, 800);
  };

  const handleClassificationChange = event => {
    selectedClassification = event.target.value;
    handleFilterChange({visibleCount: clicks * limit});
    renderTitle();

    adjustMaxHeight(elementWrapper, 800);
  };

  let root;
  const renderTitle = () => {
    root = render(
      <Title
        title={titleText}
        tags={tags}
        handleDestinationChange={handleDestinationChange}
        handleClassificationChange={handleClassificationChange}
        selectedDestination={selectedDestination}
        selectedClassification={selectedClassification}
        enableDestinationFilter={enableDestinationFilter}
        enableClassificationFilter={enableClassificationFilter}
        section={section}
      />,
      titleElement,
      root
    );
  };

  titleElement.innerHTML = '';
  renderTitle();

  const handleFilterChange = ({visibleCount, cb}) => {
    const metElements = elements
      .filter(element => {
        if (selectedDestination && selectedClassification) {
          return element.data.destinations.includes(selectedDestination) && element.data.classifications.includes(selectedClassification)
        }
        if (selectedDestination) {
          return element.data.destinations.includes(selectedDestination);
        }
        if (selectedClassification) {
          return element.data.classifications.includes(selectedClassification);
        }
        return true;
      });

    const visibleElements = visibleCount ? metElements.slice(0, visibleCount) : metElements;

    if (button) {
      if (metElements.length <= visibleCount) {
        hideButton(button);
      } else {
        showButton(button);
      }
    }

    elements.filter(element => !visibleElements.includes(element)).forEach(element => {
      element.classList.add('teaserSimpleElement--hide');
      setTimeout(() => {
        element.classList.add('teaserSimpleElement--hidden');
      }, 400);
    });
    visibleElements.forEach(element => {
      element.classList.remove('teaserSimpleElement--hidden');
      element.classList.remove('teaserSimpleElement--hide');
    });

    if (cb) cb();
  };

  if (button) {
    button.addEventListener('click', () => {
      clicks++;

      handleFilterChange({visibleCount: clicks * limit, cb: () => adjustMaxHeight(elementWrapper, 250, 500)});

      if (elements.length <= (clicks * limit)) {
        hideButton(button);
      }

    });
  }

  window.addEventListener('resize', () => adjustMaxHeight(elementWrapper));

  adjustMaxHeight(elementWrapper, 300, 500);
};
